import React from "react"

export const MenuActionsWrap = ({ children }) => (
  <div
    className="flex justify-end"
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      position: "absolute",
      top: 12,
      left: 24,
      right: 24,
      gap: 10,
      zIndex: 9999999999,
    }}
  >
    {children}
  </div>
)
